const formatPublisherAddress = (data, short = false) => {
  const {
    street,
    town,
    province,
    state,
    postcode,
  } = data;
  let address = '';
  if (street) {
    address += `${street}, `;
  }
  if (short) {
    if (town) {
      address += town;
    }
    if (postcode) {
      address += `, ${postcode}${province ? ` (${province})` : ''}`;
    }
  } else {
    if (town) {
      address += `${town}${province ? ` (${province})` : ''}`;
    }
    if (state) {
      address += `, ${state}`;
    }
    if (postcode) {
      address += `, ${postcode}`;
    }
  }

  return address;
};

export default formatPublisherAddress;
